import dataBeleidNietErnstigVka from "../../../../src/data/niet-ernstige-bloedingen-onder-vka.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBeleidNietErnstigVka,
  BasicCollapse,
  React
};